import RelativePositionComponent from 'Component/Render/RelativePosition';
import { NewPremiumItemsLayout } from 'Layouts/Farm/NewPremiumItemsLayout';
import { PopupID } from 'State/UI/PopupID';
import BaseUISystem from 'System/UI/BaseUISystem';
import Point from 'Utility/Point';
import BaseMenu from '../BaseMenu';
import { getLayout, GLayout } from 'Utility/layout/LayoutHelper';
import { FarmItemId, getFarmItemById } from 'System/Farm/Data/FarmItemData';
import Game from 'Game';
import { getFarmItemThumbnailAssetName, getFarmItemThumbnailPath } from 'System/Farm/FarmHelpers';
import { FarmStateHelper } from 'State/Player/Farm/FarmStateHelper';
import { applyDefaultButtonAnimation } from 'System/UI/UIHelper';
import { GameObjectEvent } from 'GameObject/GameObject';
import { UIActions } from 'State/UI/UIActions';
import { PlaySound } from 'System/Audio/AudioHelper';
import { FarmActions } from 'State/Farm/FarmActions';
import SpriteComponent from 'Component/Render/Sprite';
import TransformComponent from 'Component/Transform';
import Renderable from 'Component/Renderable';

export default class FarmNewPremiumItems extends BaseMenu {
    private layout: GLayout<NewPremiumItemsLayout>;
    private itemsId: FarmItemId[];
    constructor(uiSystem: BaseUISystem) {
        super(PopupID.FARM_NEW_ITEMS, uiSystem, false);
    }

    public onShow(params?: any) {
        this.layout = getLayout(NewPremiumItemsLayout);
        this.layout.root.addComponent(RelativePositionComponent);
        this.layout.root.getComponent(RelativePositionComponent).relativePosition = new Point(0.5, 0.5);
        this.element.addChild(this.layout.root);

        const { closeButton, continueButton, itemsContainer, bg, premiumTab } = this.layout;

        [closeButton, continueButton].forEach(button => {
            applyDefaultButtonAnimation(button);
            button.on(GameObjectEvent.SELECTED, () => {
                const state = Game.store.getState();

                UIActions.hidePopup(PopupID.FARM_NEW_ITEMS);

                PlaySound(!state.farmState.constructionModeEnabled ? 'construction_mode_enter' : 'construction_mode_exit');

                FarmActions.setConstructionMode(!state.farmState.constructionModeEnabled);
            });
        });

        const bgWidth = 177;
        const bgWidthPlusOffset = bgWidth + 30;
        const firstPosition = ((bgWidthPlusOffset * this.itemsId.length / 2) * -1) + 15;

        const popupWidth = Math.max((bgWidth + 30) * this.itemsId.length + 65, 800);
        bg.container.width = popupWidth;
        bg.container.pivot.x = popupWidth / 2;

        premiumTab.getComponent(TransformComponent).position.x = -(popupWidth / 2) + 85;
        closeButton.getComponent(TransformComponent).position.x = (popupWidth / 2) - 50;

        this.itemsId.forEach((id: string, index: number) => {
            const item = itemsContainer.item[index];
            const itemThumb = item.itemThumb;
            const taskSprite = item.taskSprite;

            // Set item position
            const position = firstPosition + (bgWidthPlusOffset * index);
            itemThumb.parent.getComponent(TransformComponent).position = new Point(position, 0);
            itemThumb.parent.getComponent(Renderable).visible = true;

            // Set item thumbnail texture
            itemThumb.getComponent(SpriteComponent).texture = getFarmItemThumbnailAssetName(id);

            // Set item task text
            taskSprite.getComponent(SpriteComponent).texture = `reply_task_${getFarmItemById(id).slotType}`;
        });
    }

    public async preload() {
        const state = Game.store.getState();
        const unseenPremiumItems = FarmStateHelper.getUnseenPremiumItems(state.playerState.decoItemsSeen);

        // Randomize items and get 5
        this.itemsId = [...unseenPremiumItems].sort(() => 0.5 - Math.random()).slice(0, 5);

        this.itemsId.forEach(itemId => {
            const texture = getFarmItemThumbnailAssetName(itemId);
            if (!Game.resource.existsOrQueued(texture)) {
                Game.resource.add(texture, getFarmItemThumbnailPath(itemId));
            }
        })

        super.preload();
    }
}
